/**
 * @module app.shared
 */

import { IApiQueryFilter } from './api-filters';
import { encodeFieldName, mapQueryComparisonOperator } from './api-utilities';

export class ApiQueryIsNullFilter implements IApiQueryFilter {

    constructor(public field: string, public isNull: boolean) {}

    public toString(): string {
        const operation = mapQueryComparisonOperator('eq', !this.isNull);

        const encodedField = encodeFieldName(this.field);
        const encodedValue = 'null';

        return operation.buildExpression(encodedField, encodedValue);
    }

}
